<template>
  <div class="space-y-6">
    <div class="card">
      <div class="card-header">
        Company Details
      </div>
      <div class="p-6">
        <form @submit.prevent="updateAccount()">
          <fieldset class="form-group">
            <label for="name" class="form-label">Company Name</label>
            <input id="name" type="text" class="form-input" v-model="form.name">
          </fieldset>
          <fieldset class="form-group">
            <label for="email" class="form-label">Company Email Address</label>
            <input id="email" type="text" class="form-input" v-model="form.email">
          </fieldset>
          <button type="submit" class="btn btn-primary" v-submitting="submitting">
            Save Details
          </button>
        </form>
      </div>
    </div>

    <div class="card">
      <div class="card-header">
        Location Details
      </div>
      <div class="p-6">
        <form @submit.prevent="updateAccount()">
          <fieldset class="form-group">
            <label for="country" class="form-label">Country</label>
            <select id="country" class="form-select" v-model="form.country">
              <option v-for="country in countries" :key="country.id" :value="country.id">
                {{ country.name }}
              </option>
            </select>
          </fieldset>
          <fieldset class="form-group">
            <label for="timezone" class="form-label">Time Zone</label>
            <select id="timezone" class="form-select" v-model="form.timezone">
              <option v-for="timezone in timezones" :key="timezone.name" :value="timezone.name">
                {{ timezone.name }} (GMT{{ timezone.utcOffsetStr }})
              </option>
            </select>
          </fieldset>
          <fieldset class="form-group">
            <label for="currency" class="form-label">Currency</label>
            <select id="currency" class="form-select" v-model="form.currency">
              <option v-for="currency in currencies" :key="currency.code" :value="currency.code">
                {{ currency.currency }} ({{ currency.code }})
              </option>
            </select>
          </fieldset>
          <button type="submit" class="btn btn-primary" v-submitting="submitting">
            Save Details
          </button>
        </form>
      </div>
    </div>

    <div class="card">
      <div class="card-header">
        Brand Details
      </div>
      <div class="p-6">
        <form @submit.prevent="updateAccount()">
          <fieldset class="form-group">
            <label for="color" class="form-label">Brand Colour</label>
            <div class="grid grid-cols-3 gap-1">
              <label class="relative flex items-center justify-center bg-gray-100 rounded cursor-pointer hover:bg-gray-50" :for="key" v-for="(value, key) in $store.state.colors" :key="key">
                <input type="radio" name="brandColor" v-model="form.color" :value="key" :id="key" class="absolute opacity-0 pointer-events-none">
                <div class="flex items-center justify-start w-full h-10 p-2">
                  <div class="flex items-center justify-center w-5 h-5 mr-2 text-xs text-white rounded" :style="{ 'background': `rgb(${value})` }" >
                    <div v-if="form.color === key">✓</div>
                  </div>
                  <div class="text-sm font-medium text-gray-800 truncate">
                    {{ key | capitalize }}
                  </div> 
                </div>
              </label>
            </div>
          </fieldset>
          <fieldset class="form-group">
            <label for="logo" class="form-label">Company Logo</label>
            <div class="p-6 border rounded">
              <div class="flex items-center justify-between">
                <div class="h-12">
                  <img v-if="form.logo" :src="form.logo" :alt="`${form.name} Logo`" class="w-auto h-12" />
                </div>
                <button type="button" class="btn btn-secondary btn-sm" @click="showLogoUpload = true">
                  {{ form.logo ? 'Change Logo' : 'Add Logo' }}
                </button>
              </div>
              <Collapse class="mt-4" :active="showLogoUpload" :duration="200">
                <input type="url" id="logo" ref="logo" v-model="form.logo" class="form-input" />
              </Collapse>
            </div>
          </fieldset>
          <button type="submit" class="btn btn-primary" v-submitting="submitting">
            Save Details
          </button>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapGetters, mapState } from 'vuex'
  import ct from 'countries-and-timezones'
  import cc from 'currency-codes'
  import FileUploader from '@/components/FileUploader'

  export default {
    name: 'SettingsCompany',

    metaInfo: {
      title: 'Company Settings'
    },

    components: {
      FileUploader
    },

    created () {
      this.form = JSON.parse(JSON.stringify(this.account))
    },

    computed: {
      ...mapState(['user']),
      ...mapGetters(['account']),

      countries () {
        let countries = []
        let unsorted = ct.getAllCountries()
        for (let key in unsorted) {
          countries.push(unsorted[key])
        }
        countries.sort((a, b) => {
          if (a.name < b.name) { return -1 }
            if (a.name > b.name) { return 1 }
              return 0
          })
        return countries
      },

      timezones () {
        if (this.selectedCountry) {
          return ct.getTimezonesForCountry(this.selectedCountry.id)
        } else {
          return []
        }
      },

      currencies () {
        if (this.selectedCountry) {
          return cc.country(this.selectedCountry.name.toLowerCase())
        } else {
          return []
        }
      },

      selectedCountry () {
        return this.countries.find(ct => ct.id === this.form.country)
      }
    },

    data () {
      return {
        showLogoUpload: false,
        submitting: false,
        uploading: false,
        logo: '',
        form: {
          name: '',
          email: '',
          country: '',
          timezone: '',
          currency: '',
          color: '',
          logo: ''
        }
      }
    },

    methods: {
      async updateAccount () {
        try {
          this.submitting = true
          await this.$api.patch(`account/${this.$route.params.account}/accounts/${this.form.id}`, this.form)
          this.$store.dispatch('syncUser', this)
          this.$toasted.show('Account Updated')
        } catch (error) {
          console.error(error)
          this.$toasted.error(error.response.data.message)
        } finally {
          this.submitting = false
        }
      }
    }
  }
</script>